/* eslint-disable @typescript-eslint/no-explicit-any */
import type { IMockStore } from '@graphql-tools/mock';

export const rand = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;

export type Size = number | [number, number];

export function oneRef<T = any>(
  store: IMockStore,
  typeName: string,
  defaults?: Record<string, any>,
) {
  // IMockStore.get(typeName, defaultValues?) -> Ref
  return store.get(typeName, defaults as any) as unknown as T;
}

export function manyRefs<T = any>(
  store: IMockStore,
  typeName: string,
  size: Size,
  defaults?: Record<string, any>,
) {
  const n = Array.isArray(size) ? rand(size[0], size[1]) : size;
  return Array.from({ length: n }, () => oneRef<T>(store, typeName, defaults));
}
